import InputController from '@/components/inputs/InputController';
import Select from '@/components/inputs/Select';
import language from '@/config/language';
import { Theme } from '@/state/reducers/settingSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { Tab } from '@headlessui/react';
import { useMemo } from 'react';

export const timezoneOptions = [
    { label: 'UTC Timezone', value: 'UTC' },
    { label: 'Local Timezone', value: 'local' }
];

export const themeOptions: { label: string; value: Theme }[] = [
    { label: 'Dark Theme', value: 'dark' },
    { label: 'Light Theme', value: 'light' }
];

export const languageOptions = [
    { label: `${language['en'].common['en']} (UK)`, value: 'en' },
    { label: `${language['dk'].common['dk']} / ${language['en'].common.dk}`, value: 'dk' },
    { label: `${language['zh'].common['zh']} / ${language['en'].common.zh}`, value: 'zh' },
    { label: `${language['ar'].common['ar']} / ${language['en'].common.ar}`, value: 'ar' },
    { label: `${language['es'].common['es']} / ${language['en'].common.es}`, value: 'es' }
];

export const millisecondShowOptions = [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false }
];

const GeneralTab = () => {
    const lang = useLanguage();
    const langThemeOptions = useMemo(() => {
        return [
            { label: lang.common.dark, value: 'dark' },
            { label: lang.common.light, value: 'light' }
            // { label: lang.common.system, value: 'system' }
        ];
    }, [lang]);

    return (
        <Tab.Panel className="p-2 py-3 sm:p-4 h-auto lg:h-[400px]">
            <div className="space-y-4">
                <div className="space-y-3 sm:space-y-2">
                    <InputController name="general.timezone" label={lang.settings.timezoneSettings} required>
                        <Select options={timezoneOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1">
                        {lang.settings.timezoneSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                </div>
                <InputController name="general.theme" label={lang.settings.themeSettings} required>
                    <Select options={langThemeOptions} />
                </InputController>
                <InputController name="general.language" label={lang.settings.languageSettings} required>
                    <Select options={languageOptions} />
                </InputController>
                <InputController
                    name="general.showMilliseconds"
                    label={lang.settings.showMillisecondsSettings}
                    required>
                    <Select options={millisecondShowOptions} />
                </InputController>
            </div>
        </Tab.Panel>
    );
};

export default GeneralTab;
